import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map, of, shareReplay, switchMap, tap } from 'rxjs';
import { GeneralParameter } from '../../models/generalParameter.model';
import { ApiService } from '../api.service';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class GeneralParameterService {
  constructor(private http: HttpClient, private apiService: ApiService, private authService: AuthService) { }

  apiUrl = `${this.apiService.apiUrl}/generalparameters`;

  // Variable to store the HTTP call Observable
  private generalParameters$: Observable<GeneralParameter[]> | null = null;

  getGeneralParameters(name?: string): Observable<GeneralParameter[] | GeneralParameter> {
    // First, check if the data is already in sessionStorage
    let generalParams = this.authService.getGeneralParameters();
    if (generalParams !== undefined && generalParams.length > 0) {
      if (name && name !== '') {
        // Return the specific parameter if a name is provided
        return of(generalParams.find(x => x.name === name) || []);
      }
      // Return all parameters if no name is provided
      return of(generalParams);
    }

    // If the HTTP call is already in progress, return the same Observable
    if (!this.generalParameters$) {
      this.generalParameters$ = this.http.post<GeneralParameter[]>(`${this.apiUrl}`, true).pipe(
        tap((_generalParams: GeneralParameter[]) => {
          // Store the fetched parameters in sessionStorage
          this.authService.setGeneralParameters(JSON.stringify(_generalParams));
        }),
        shareReplay(1) // Share the response among multiple subscribers
      );
    }

    // Wait for the HTTP response
    return this.generalParameters$.pipe(
      switchMap(() => {
        let generalParams = this.authService.getGeneralParameters();
        if (generalParams) {
          // Return specific or all parameters based on the name argument
          return of(name ? generalParams.find(x => x.name === name) || [] : generalParams);
        } else {
          // Return an empty array if no parameters are available
          return of([]);
        }
      })
    );
  }
}
